import axios from "axios";
import { getPrebookUrl } from "config/configUtils";
import { useCallback, useState } from "react";
import useAppSelector from "hooks/useAppSelector";

type Props = {
  transactionId?: string;
  itemUuid: string | null;
  internalMessage?: string;
  customerMessage?: string;
};

export const usePostRefundMusement = () => {
  const sessionId = useAppSelector((state) => state.authentication.sessionId);

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const deletePostRefundMusement = useCallback(
    async ({
      transactionId,
      itemUuid,
      internalMessage = "",
      customerMessage = "",
    }: Props) => {
      setLoading(true);
      const URL = `${getPrebookUrl()}/api/payments/opp/refund/${transactionId}/items/${itemUuid}`;

      const response = await axios
        .post(
          URL,
          { internalMessage, customerMessage },
          {
            headers: {
              SessionId: sessionId,
            },
          }
        )
        .catch((error) => {
          setError(error);
        });

      setData(response?.data);
      setLoading(false);
    },
    [sessionId]
  );

  return { deletePostRefundMusement, data, loading, error };
};
